import type { operations } from '@molchanovs/api-contract';
import { z } from 'zod';

export type CrmCustomerSourceIdentitiesResponse =
  operations['getApiV1SourceIdentities']['responses'][200]['content']['application/json'];
export type CrmCustomerSourceIdentity =
  CrmCustomerSourceIdentitiesResponse['data']['items'][number];
export type CrmCustomerSourceIdentityFreshness = CrmCustomerSourceIdentity['freshness'];
export type CrmCustomerSourceIdentityAnomaly = CrmCustomerSourceIdentity['anomalyWarnings'][number];

export const crmCustomerSourceIdentityFreshnessSchema = z.enum(['fresh', 'stale', 'unknown']);
export const crmCustomerSourceIdentityAnomalySchema = z.enum([
  'multiple_primary',
  'retired_primary',
  'observation_order_invalid',
  'future_observation',
]);

const sourceIdentitySchema = z
  .object({
    anomalyWarnings: z.array(crmCustomerSourceIdentityAnomalySchema).max(3).readonly(),
    freshness: crmCustomerSourceIdentityFreshnessSchema,
    lastObservedAt: z.iso.datetime(),
    lifecycle: z.enum(['active', 'retired']),
    primaryState: z.enum(['primary', 'secondary']),
    sourceSystem: z.enum(['bubble', 'move']),
  })
  .strip();

export const crmCustomerSourceIdentitiesResponseSchema: z.ZodType<CrmCustomerSourceIdentitiesResponse> =
  z
    .object({
      data: z
        .object({
          items: z.array(sourceIdentitySchema).max(50).readonly(),
        })
        .strip(),
    })
    .strip();
